import { css } from "styled-components"

export const forMobileOnly = css`max-width: 767px`
export const forTabletPortraitUp = css`min-width: 768px`
export const forTabletLandscapeUp = css`min-width: 1024px`
